import axios from 'axios'
import { getLocalStorage, removeLocalStorage} from '../../helpers/localStorage.js'


const BASE_URL = process.env.REACT_APP_BASE_URL

export const apiService = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
})

apiService.interceptors.request.use(
    (config) => {
        let jwt = ''

        const identifynAdminToken = getLocalStorage('identifynadmintoken')
            jwt = identifynAdminToken

        if (jwt) {
            config.headers['Authorization'] = `Bearer ${jwt}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

apiService.interceptors.response.use(
    response => response,
    error => {
        console.log('error', error)
        if(error.response.status === 401) {
            // window.location = '/login'
            removeLocalStorage('identifynadmintoken')
        }
        if (error.response.status === 403 && error.response.data.message === "permission denied") {
            window.location = '/no-auth'
        }
        return Promise.reject(error?.response?.data)
    }
)
